import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSpring, animated } from "react-spring";
import {
  Background,
  ModalContent,
  CloseModalButton,
  Title,
  StatusText,
  ToggleContainer,
} from "./styles";
import ToggleSwitch from "../../ToogleSwitch";
import api from "../../../services/api";
import Swal from "sweetalert2";

export default function ModalPermitirCancelarDoacao({
  showModal,
  setShowModal,
}) {
  const modalRef = useRef();
  const [permitido, setPermitido] = useState(false);
  const [loading, setLoading] = useState(false);

  const animation = useSpring({
    config: {
      duration: 150,
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`,
  });

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) setShowModal(false);
    },
    [setShowModal, showModal]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  const fetchStatus = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(
        "/configs/permission-to-cancel-donation"
      );
      const raw = response.data;
      const valor = Array.isArray(raw)
        ? raw[0]?.permitir_cancelar_doacao
        : raw?.permitir_cancelar_doacao;
      setPermitido(!!valor);
    } catch (error) {
      Swal.fire({
        title: "Atenção!",
        text: "Não foi possível carregar a configuração atual.",
        icon: "warning",
        confirmButtonColor: "var(--red-color)",
      });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (showModal) fetchStatus();
  }, [showModal, fetchStatus]);

  async function handleToggle() {
    if (loading) return;
    setLoading(true);
    try {
      await api.patch("/admin/configs/permission-to-cancel-donation");
      setPermitido((prev) => !prev);
    } catch (error) {
      Swal.fire({
        title: "Atenção!",
        text: "Não foi possível alterar a configuração.",
        icon: "warning",
        confirmButtonColor: "var(--red-color)",
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {showModal ? (
        <Background
          ref={modalRef}
          onClick={(e) => {
            if (modalRef.current === e.target) setShowModal(false);
          }}
        >
          <animated.div style={animation}>
            <ModalContent>
              <Title>Cancelamento do Agendamento</Title>
              <StatusText>
                Doadores {permitido ? "PODEM" : "NÃO PODEM"} cancelar o agendamento.
              </StatusText>
              <ToggleContainer>
                <ToggleSwitch isActive={permitido} onToggle={handleToggle} />
              </ToggleContainer>
              <CloseModalButton onClick={() => setShowModal(false)} />
            </ModalContent>
          </animated.div>
        </Background>
      ) : null}
    </>
  );
}
